import { Box, Button, Divider, Grid, TextareaAutosize, Typography,CircularProgress, Tooltip } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getLMARequestDetails, downloadLmaPackageDoc, downloadDocumentByComment, submitBorrowerComment, uploadDocumentInComment, downloadCommentLmaDocument, deleteCommentLmaDocument, getSpocDetails } from '../../actions';
import { getAppSource, getUserType, renderDefaultMsg, isAdminCheck } from '../../helpers';
import { decrypt } from '../../helpers/encrypt';
import { useStyles } from './styles';
import { withStyles } from '@material-ui/core/styles';
import { LMA_FILE_SIZE_LIMIT } from '../../helpers/constants';
import { FileSizeAlert } from './../LmaDetails/FileSizeAlert';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import HelpIcon from '@material-ui/icons/Help';
import InfoIcon from '@material-ui/icons/Info';
import DeleteIcon from '@material-ui/icons/Delete';

import Completed from '../../assets/RequestDocument/Completed.svg';
import Pending3 from '../../assets/RequestDocument/Pending3.svg';
import SubmittedYellow from '../../assets/RequestDocument/SubmittedYellow.svg';

import image from '../../assets/image.png';
import pdf from '../../assets/pdf.png';
import download from '../../assets/download.png';
import attachment from '../../assets/attachment.png';
import denied from '../../assets/denied.png';
import documentRequired from '../../assets/documentRequired.png';

import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';
import CustomBreadcrum from '../Breadcrum';
import Cookies from 'js-cookie';
import moment from 'moment';
import './styles.js';

const CustomStepIcon = (props,status) => {
  
  const { icon } = props;
  
  let displayedIcon=SubmittedYellow;
  if(status=='Submitted'){
    if(icon===1){
      displayedIcon=Completed;
    }
    else if(icon===2){
      displayedIcon=Pending3;
    }
    else if(icon===3){
      displayedIcon=Pending3;
    }
  }
  else if(status=='Under Review'){
   
    if(icon===1){
      displayedIcon=Completed;
    }
    else if(icon===2){
      displayedIcon=SubmittedYellow;
    }
    else if(icon===3){
      displayedIcon=Pending3;

    }
  }
  else if(status=='Complete'){
      
      if(icon===1){
        displayedIcon=Completed;
      }
      else if(icon===2){
        displayedIcon=Completed;
      }
      else if(icon===3){
        displayedIcon=Completed;
      }
  }
  else if(status=='Incomplete'){
      
    if(icon===1){
      displayedIcon=Completed;
    }
    else if(icon===2){
      displayedIcon=documentRequired;
    }
    else if(icon===3){
      displayedIcon=Pending3;
    }
 }
 else if(status=='Denial'){
      
  if(icon===1){
    displayedIcon=Completed;
  }
  else if(icon===2){
    displayedIcon=Completed;
  }
  else if(icon===3){
    displayedIcon=denied;
  }
}
  
  return (
    <div style={{  marginTop: '-10px', padding: '5px'}}>      
      <img src={displayedIcon}/>
    </div>
  );
};

export const LmaStatus = (props) => {
 
  const mytheme = useSelector(state => state.theme);
  const LightTooltip = withStyles((theme) => ({
    arrow: {
      color: '#235A86'
    },
    tooltip: {
      backgroundColor: '#235A86',
      color: '#fffff',
      fontFamily: "Montserrat",
      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
      padding: "16px",
      fontSize: 14,
      maxWidth: 400,
      fontWeight: 500,
      borderRadius: 8
    },
  }))(Tooltip);

  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const fileInputRef = useRef(null);
  const userName = Cookies.get('firstLastName')

  const [submitComentLoader, setSubmitLoader] = useState(false);
  const [userComment, setUserComment] = useState();
  const [openClassification, setOpenClassification] = useState(true);
  const [commentsDoc, setCommentsDoc] = useState([]);
  const [requestDetails, setRequestDetails] = useState();
  const [errMessage, setErrorMessage] = useState('');
  const [requestStatus, setRequestStatus] = useState([]);
  const [clarificationHistory, setClarificationHistory] = useState([])
  const [uploadDocLoader, setUploadDocLoader] = useState(false);
  const [alertStatus, setAlertStatus] = useState(false);
  const [file, setFilesName] = useState('');
  
  useEffect(() => {
    if (props.accountNumber) {
      getRequestDetail()
      getSpocDetail()
    }
  }, [props])

  const getRequestDetail = async () => {
      const data = {
        "lmaApplicationId": 0,
        "accountNumber": props.accountNumber,
        "privateLabelUrl": Cookies.get("privateLabelUrl"),
        "ipAddress": Cookies.get('publicIp'),
        "browser": Cookies.get("browser"),
        "appSource": getAppSource(),
        "userType": getUserType(),
        "userName": ""
      };

      const res = await getLMARequestDetails(data);
      if (res?.responseData?.lstResponseStatus[0]?.statusCode == 0) {
        const details = res?.responseData?.responseData;
        setRequestDetails(details)
        setClarificationHistory(details.clarificationHistory)
        getSteps(details)
        getLMAStatus(details.lmaStatus)
        if (details.lmaStatus == 'Incomplete') {
          setOpenClassification(true)
        }
      } else {
          setErrorMessage(renderDefaultMsg('400'))
      }
  }

  const getSpocDetail = async () => {
    const data = {
      "accountNumber": props.accountNumber,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    };

    const res = await getSpocDetails(data);
    if (res?.responseData?.lstResponseStatus[0]?.statusCode == 0) {
      getLMAStatus(res?.responseData?.responseData?.lmaStatus)
    } 
  }

  const getLMAStatus = (lmaStatus) => {
    if ((lmaStatus.toLowerCase() == "blank") || (lmaStatus.toLowerCase() == "spoc") || (lmaStatus.toLowerCase() == 'lma not allowed')) {
      history.push('/FinancialHardship')
    } else if (lmaStatus.toLowerCase() == "in progress") {
      history.push('/LmaDetails')
    } 
  }

  const getSteps = (requestHistorys) => {
    var stepperStatus = [];
    if ((requestHistorys.lmaStatus == 'Submitted') || (requestHistorys.lmaStatus == 'Under Review') || (requestHistorys.lmaStatus == 'Complete')) {
    stepperStatus = [{ status: 'Submitted', createdDateTime: null }, { status: 'Under Review', createdDateTime: null }, { status: 'Complete', createdDateTime: null }]; 
    } else if ((requestHistorys.lmaStatus == 'Incomplete')) {
      stepperStatus = [{ status: 'Submitted', createdDateTime: null }, { status: 'Incomplete', createdDateTime: null }, { status: 'Complete', createdDateTime: null }];
    } else if ((requestHistorys.lmaStatus == 'Denial')) {
      stepperStatus = [{ status: 'Submitted', createdDateTime: null }, { status: 'Under Review', createdDateTime: null }, { status: 'Denial', createdDateTime: null }];
    } 
    
    let stepperData = stepperStatus.map((e) => {
      let temp = requestHistorys.requestStatusHistory.find(element => element.status == e.status)
      if (temp) {
        e.createdDateTime = temp.createdDateTime;
      }
      return e;
    })
    setRequestStatus(stepperData)
  }
 
  const calculateCommentLenth = () => {
    const length = userComment?.length
    if (isNaN(length)) {
      return 0
    } else {
      return length
    }
  }

  const setUserCommentList = (event) => {
    setUserComment(event.target.value)
  }

  const openClass = () => {
    setOpenClassification(!openClassification)
  }
 
  const handleSubmitComment = async () => {
    setSubmitLoader(true)
    const data = {
      "lmaApplicationId": 0,
      "additionalDocIdList" : commentsDoc.map((doc) => doc.requestId),
      "accountNumber": props.accountNumber,
      "comment": userComment,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    };
    const res = await submitBorrowerComment(data);
    if (res?.responseData.lstResponseStatus[0]?.statusCode == 0) {
      setSubmitLoader(false)
      getRequestDetail()
      setUserComment('');
    } else {
      setSubmitLoader(false)
    }
  }

  const downloadDocument = async (key) => {
   
    const data = {
      "additionalDocID": key.requestId,
      "accountNumber": props.accountNumber,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    };
    const response = await downloadCommentLmaDocument(data)
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download',  key.fileName);
      document.body.appendChild(link);
      link.click();
    } else {
      setErrorMessage(renderDefaultMsg('400'))
    }
  }

  const downloadDocumentsByComment = async (request) => {
    const data = {
      "accountNumber": props.accountNumber,
      "lmaApplicationId": 0,
      "responseId": request.responseId,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    };
    const response = await downloadDocumentByComment(data)
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', request.fileName);
      document.body.appendChild(link);
      link.click();
    } else {
      setErrorMessage(renderDefaultMsg('400'))
    }
  }

  const downloadLmaPackage = async () => {
    const data = {
      "accountNumber": props.accountNumber,
      "id": 0,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    };
    const response = await downloadLmaPackageDoc(data)
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', decrypt(props.accountNumber) + '_' + 'LMA_PACKAGE');
      document.body.appendChild(link);
      link.click();
    } else {
      setErrorMessage(renderDefaultMsg('400'))
    }
  }

  const getAbbrevation = (word) => {
    const bits = word.trim().split(' ');
    return bits
      .map((bit) => bit.charAt(0))
      .join('')
      .toUpperCase();
  }

  const shortText = (text) => {
    if ((text !== '') && (text !== null)) {
      return text?.length < 20 ? text : text?.substr(0, 20) + '...'
    } else {
      return text
    }
  }  
 
  const getLmaStatus = (lmaStatus) => {
    if (lmaStatus == 'Incomplete') {
      return 'Documents Required'
    } else if (lmaStatus == 'Denial') {
      return 'Denied'
    } else if (lmaStatus == 'Complete') {
      return 'Completed'
    } else {
      return lmaStatus
    }
  }

  const submitLmaDetail = async (files) => {
    setUploadDocLoader(true)
    const formData = new FormData();
    formData.append('lmaApplicationId', 0);
    formData.append('accountNumber', props.accountNumber);
    formData.append('documents', files);
    formData.append('privateLabelUrl', Cookies.get("privateLabelUrl"));
    formData.append('browser', Cookies.get("browser"));
    formData.append('appSource', getAppSource());
    formData.append('userType', getUserType());
    formData.append('ipAddress', Cookies.get('publicIp'));
    formData.append('userName', "");
    const res = await uploadDocumentInComment(formData);
    if ((res?.responseData?.lstResponseStatus[0]?.statusCode == 0)) {
      setUploadDocLoader(false)
      setCommentsDoc(prevItems => [...prevItems, {fileName: files.name , requestId: res?.responseData?.responseData}])
    } else {
      setUploadDocLoader(false)
    }
  }

  const openFileDialog = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFile = (event) => {
    event.persist();
    if (event.target.files[0].size > LMA_FILE_SIZE_LIMIT) {
      setFilesName(event.target.files[0].name)
      setAlertStatus(true)
    } else {
      submitLmaDetail(event.target.files[0])
    }
  }

  const handleInputFile = (e) => {
    e.target.value = null;
  }

  const deleteDoc = async (key, index) => {
    const data = {
      "additionalDocID": key.requestId,
      "accountNumber": props.accountNumber,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    };
    const response = await deleteCommentLmaDocument(data)
    if ((response?.responseData?.lstResponseStatus[0]?.statusCode == 0)) {
      setCommentsDoc(prevItems => {
        const newItems = [...prevItems];
          newItems.splice(index, 1);
        return newItems;
      });
    } else {
      setErrorMessage(renderDefaultMsg('400'))
    }
  }
 
  const handleAlertClose = () => {
    setAlertStatus(false)
  }

  if (uploadDocLoader) {
    return (
      <Box className={classes.loadingRoot}>
        <CircularProgress />
      </Box>
    )
  } 

  return (
    <CssBaseline>
       <Box container="true" maxWidth='xl' className={classes.root}>      
        <Box className={classes.container}>
            <CustomBreadcrum backPage="Payments" backPageLink="/PaymentOption" activePage="Financial Hardship" />
              <h1 className={classes.pageHeading} color="textPrimary" component='h4'>Loss Mitigation Application</h1>
              <Box className={classes.infoStrip}>
               
                 <Box className={classes.boxContainer}>
                    <Box className={classes.hardshipContainer}>
                    <p className={classes.errorMsg} dangerouslySetInnerHTML={{ __html: errMessage !== '' ? errMessage : '' }} />

                    <Typography className={classes.title}>Loss Mitigation Application <span className={classes.hours}>(Submitted on {moment(requestDetails?.submittedDate).format('LL')})</span></Typography>  
                    <p className={classes.line}></p>
                 <Box>

                  <Grid container className={classes.accordianContainer}>
                    <Grid item md={12} xs={12} lg={12}>

                      <Box style={{ paddingBottom: '20px' }}>
                            <Box className={classes.accordian}>

                                <Box className={classes.accDetails}>
                                 {(requestDetails?.lmaStatus == 'Complete') && <Box className={classes.infoTopBox}>
                                    <Typography className={classes.next}>
                                      <HelpIcon style={{ color: '#F7B15C' }} className={classes.helpIcon} />
                                    </Typography>
                                    <Typography className={classes.whatsNext}>What's Next?</Typography>
                                    <Typography className={classes.new}>Within thirty (30) days of receipt of a complete application, we will let you know which loss mitigation option, if any, are available to you and will inform you of your next steps to accept our offer. Please understand that we cannot guarantee that you will receive any (or a particular type of) assistance.</Typography> 
                                </Box> }

                                {(requestDetails?.lmaStatus == 'Denial') && <Box className={classes.infoTopBox}>
                                    <Typography className={classes.next}>
                                      <InfoIcon style={{ fill: "#B91717" }} className={classes.helpIcon} />
                                    </Typography>
                                    <Typography className={classes.denied}>Unfortunately, we are unable to honor your application at this moment. For a detailed explanation, please refer to the attached letter in the comments section.</Typography> 
                                </Box> }

                                    <Box>
                                        <Stepper alternativeLabel >
                                          {requestStatus.map((label,index) => (
                                            <Step key={label} >
                                              <StepLabel StepIconComponent={(props)=>CustomStepIcon(props, requestDetails.lmaStatus)} status={label} step={index} >
                                                <Box>
                                                 <Box style={{display: 'inline-flex'}}>
                                                  <Box className={classes.label} style={{color: label.createdDateTime !== null ? '#235A86' : '#B4B4B4'}}>{getLmaStatus(label.status)}</Box>
                                                    {((label.status == 'Under Review') && (requestDetails.lmaStatus == 'Under Review')) && <LightTooltip
                                                    arrow  placement="bottom"
                                                      title="Our team is currently reviewing your documents. This process may take up to 5 business days from the date of your initial submission or any additional documents provided."
                                                    >
                                                  <InfoIcon style={{ fill: "#007FFF", marginLeft: "5px" }} />
                                                  </LightTooltip>}
                                                  {((label.status == 'Incomplete') && (requestDetails.lmaStatus == 'Incomplete')) && <LightTooltip
                                                    arrow  placement="bottom"
                                                      title="Please refer the comments section below for required further action."
                                                    >
                                                  <InfoIcon style={{ fill: "#007FFF", marginLeft: "5px" }} />
                                                  </LightTooltip>}
                                               
                                                </Box> 
                                                  {label?.createdDateTime !== null && <Box className={classes.date}>{moment(label.createdDateTime).format('MM/DD/YYYY')} 
                                                </Box>}
                                                                  
                                                </Box>
                                              </StepLabel>
                                            </Step>
                                          ))}
                                        </Stepper>
                                    </Box>

                                  {requestDetails?.isDisplayPaymentMessage &&
                                    <Box className={classes.infoTopBox}>
                                      <Typography style={{paddingBottom: "15px", paddingTop: "15px"}}><span className={classes.note} >Please note:</span> <span className={classes.review} >While we review your application, please continue to make your current monthly mortgage payment by your normal due date to avoid any delinquency or late charges on your account.</span></Typography>
                                    </Box>}
                                    
                                    <Box>
                                      <p className={classes.uploadedDoc}></p>
                                      <Typography className={classes.title}>Uploaded Form & Documents:</Typography>  
                                      <Box className={classes.uploadedImage}>
                                          <Box className={classes.uploadedImg}>
                                              <img className={classes.checkImg} src={pdf} alt='pdf' /> 
                                              <Typography className={classes.pkgText} onClick={() => downloadLmaPackage()}>Uploaded Form & Documents</Typography>
                                            </Box>
                                        </Box>
                                        <p className={classes.uploadedDoc}></p>
                                    </Box> 

                                    { ((requestDetails?.lmaStatus == 'Incomplete') || ((requestDetails?.lmaStatus == 'Complete') && (clarificationHistory.length > 0)) || ((requestDetails?.lmaStatus == 'Under Review') && (clarificationHistory.length > 0)) || ((requestDetails?.lmaStatus == 'Denial') && (clarificationHistory.length > 0))) &&
                                    <Box className={classes.clarificationSection}>
                                      <Box className={classes.details1}><ExpandMoreIcon className={`${openClassification ? classes.collapse_icon : classes.expand_icon}`} onClick={openClass} /> <span className={classes.requestHistory} onClick={openClass} >Comments ({clarificationHistory.length})</span>
                                    
                                      </Box>
                                      <p className={classes.line}></p>
                                      { (requestDetails?.lmaStatus == 'Incomplete') &&
                                      <Box className={classes.heading}>You can add comments, documents, clarifications etc below for a smoother transition of your application.</Box> }
                                      
                                      {openClassification && <Box className={classes.documentDetails}>
                                      { (requestDetails?.lmaStatus == 'Incomplete') &&
                                                  <Grid item xs={12} sm={12} md={12}>
                                                    <Grid item xs={12} sm={12} md={6} style={{ display: 'flex', marginTop: '10px' }}>
                                                      <Grid xs={2} sm={2} md={1}>

                                                        {<Typography className={classes.nameTagUN}>
                                                          <span className='text'>{getAbbrevation(userName)}</span>
                                                        </Typography>}
                                                      </Grid>

                                                      <Grid xs={10} sm={10} md={10} style={{display: 'flex'}}>
                                                        <Typography className={classes.headingText}>{userName}</Typography>
                                                        <Typography className={classes.headingDate}>{moment(new Date()).format('MM/DD/YYYY')}</Typography>
                                                      </Grid>
                                                    </Grid>

                                                    <Box className={`${classes.agentComment} wdt`}>
                                                      <Box className={classes.textareaSection}>
                                                        <TextareaAutosize
                                                          style={{ height: '56px' }}
                                                          color="primary"
                                                          id={`outlined_impacted250`}
                                                          variant="outlined"
                                                          type="text"
                                                          name="comments"
                                                          autoFocus
                                                          maxLength="500"
                                                          onChange={(event) => setUserCommentList(event)}
                                                          value={userComment}
                                                          placeholder='Mention your clarifications here or attach the requested document(s)'
                                                          className={classes.textArea}
                                                        />
                                                         <Typography className={classes.textAreaValidation}>{calculateCommentLenth()}/500</Typography>

                                                      </Box>
                                                    </Box>
                                                   
                                                    <Box className={classes.uploadedDocument}>
                                                    {(commentsDoc.length > 0) && commentsDoc.map((commentDoc, i) => {
                                                      return (<>
                                                            { !commentDoc.fileName.includes('pdf') ? <img className={classes.checkImg} src={image} alt='img' /> :  <img className={classes.checkImg} src={pdf} alt='pdf' /> } 
                                                            <Typography className={classes.fileText} onClick={() => downloadDocument(commentDoc)}>{commentDoc.fileName}</Typography>
                                                            <DeleteIcon color="action" onClick={() => deleteDoc(commentDoc, i)} style={{cursor: 'pointer', color: '#4D4D4D'}}></DeleteIcon>
                                                        </>) })}
                                                      </Box>
                                                   
                                                  </Grid>
                                                  }

                                              { (requestDetails?.lmaStatus == 'Incomplete') &&
                                                <Grid container >
                                                  <Grid item xs={12} sm={12} md={8}></Grid>
                                                  <Grid item xs={12} sm={12} md={4} className={classes.chooseFile}>
                                                    <Box className={classes.uploadedDocument}>
                                                      <input
                                                        accept=".pdf, image/png, image/jpg, image/jpeg"
                                                        type="file"
                                                        ref={fileInputRef}
                                                        style={{display: 'none'}}
                                                        onClick={(e) => handleInputFile(e)}
                                                        onChange={(e) => handleFile(e)}
                                                          />
                                                        <img className={classes.checkImg} src={attachment} alt='img' onClick={() => openFileDialog()}/> 
                                                        <Typography className={classes.fileText}  onClick={() => openFileDialog()}>choose File </Typography>
                                                    </Box>

                                                  { submitComentLoader ?
                                                    <Button disabled={true} type='submit' className={classes.subBtn} variant="contained" color='primary'>
                                                      <CircularProgress color='primary' style={{height:'24px',width:'24px'}}/>
                                                    </Button>:
                                                    <Button
                                                      onClick={() => handleSubmitComment()}
                                                      className={classes.subBtn}
                                                      variant="contained"
                                                      disabled={!userComment || isAdminCheck()}
                                                      color="primary">
                                                      SUBMIT </Button> }
                                                      </Grid>
                                                </Grid> }

                                          {clarificationHistory.map((commentData, i) => {
                                            return (<Grid container key={i}>
                                              <Grid item md={12} lg={12} xs={12} style={{ marginBottom: '15px' }} >
                                                <Box>
                                                  <Grid container>

                                                    <Grid item xs={12} sm={12} md={6} style={{ display: 'flex' }}>
                                                      <Grid xs={2} sm={2} md={1}>
                                                        {commentData.commentByAgent && <Typography className={classes.nameTag}>
                                                          {<span className='text'>AC</span>}
                                                        </Typography>}
                                                        {!commentData.commentByAgent && <Typography className={classes.nameTagUN}>
                                                          <span className='text'>{getAbbrevation(userName)}</span>
                                                        </Typography>}
                                                      </Grid>

                                                      <Grid xs={10} sm={10} md={10} style={{display: 'flex'}}>
                                                        <Typography className={classes.headingText}>{commentData.commentByAgent ? commentData.agentName : userName}</Typography>
                                                    
                                                        <Typography className={classes.headingDate}>{moment(commentData.createdDateTime).format('MM/DD/YYYY')}</Typography>
                                                      </Grid>
                                                    </Grid>

                                                    <Grid item xs={12} sm={12} md={12}>
                                                      <Typography className={classes.agentComment} dangerouslySetInnerHTML={{ __html: commentData.comment }}></Typography>
                                                      { commentData?.fileName?.includes('pdf') &&
                                                      <Box className={classes.commentImage}>
                                                        <Box className={classes.uploadedImgBox}>
                                                          { !commentData.fileName.includes('pdf') ? <img className={classes.checkImg} src={image} alt='img' /> :  <img className={classes.checkImg} src={pdf} alt='pdf' /> }
                                                          <Typography className={classes.imageText} onClick={() => downloadDocumentsByComment(commentData)}>{shortText(commentData.fileName)}</Typography>
                                                          <img className={classes.checkImg} src={download} alt='download' style={{cursor: 'pointer'}} onClick={() => downloadDocumentsByComment(commentData)}/> 
                                                          
                                                        </Box>
                                                    </Box>}
                                                    </Grid>

                                                  </Grid>

                                                </Box>
                                              </Grid>
                                            </Grid>)
                                          })}
                                      </Box>}
                                    </Box>}
                                  </Box>
                            </Box>
                        </Box>
                      
                    </Grid>
                  </Grid>
                </Box>
     
              </Box>
            
          </Box>
        </Box>
       </Box>
      </Box>
      <FileSizeAlert
        open={alertStatus}
        handleAlertClose={handleAlertClose}
        file={file}
      />  
    </CssBaseline >
  )
}
